import { Pipe, PipeTransform } from '@angular/core';
import { Utilisateur } from '../../utilisateur/models/utilisateur';
import { environment } from '@perval/shared';
import { MenuItem } from '../menus/main-menu';

@Pipe({
  name: 'resolveRoute',
  standalone: true,
  pure: true,
})
export class ResolveRoutePipe implements PipeTransform {
  transform(item: MenuItem, user: Utilisateur): string {
    if (!item || !user) {
      return '';
    }

    if (item?.label === 'Modifier mon mot de passe') {
      return `${environment.host}/user/${user.id}/password`;
    }

    return item.route ?? '';
  }
}
